import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Step, StepOrder } from './procedure.model';

@Injectable()
export class StepService {

  private _step: Step;
  private _selectedStep: number = -1;

  constructor() { }

  get step() : Step{
    return this._step;
  }

  set step(step : Step) {
    this._step = step;
  }

  get selectedStep(): number {
    return this._selectedStep;
  }

  set selectedStep(value: number) {
    this._selectedStep = value;
  }

}
